/**
 * @desc 根据会员ID查询冻结详情
 */
import {
  FreezeRecordDto,
  FreezeRecordQuery
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryFreezeRecordParameter = FreezeRecordQuery

const method = 'GET'
const url = '/trade/member/unfreezeApply/freezeRecord'

export const queryFreezeRecordApi = (
  params?: QueryFreezeRecordParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<FreezeRecordDto>>({
    method,
    url,
    params,
    ...config
  })
}

queryFreezeRecordApi.method = method
queryFreezeRecordApi.url = url
